var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgOrangeRing251(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 204,
    height: 159,
    viewBox: "0 0 204 159",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Ellipse 13",
    opacity: 0.6,
    filter: "url(#filter0_f_153_96)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M50.5157 59.3362C59.3431 54.6507 69.007 51.7498 78.9555 50.7991C88.9041 49.8484 98.9425 50.8665 108.498 53.7953C118.053 56.7241 126.937 61.5063 134.644 67.8687C142.351 74.2311 148.729 82.0493 153.415 90.8767L119.805 108.716C117.462 104.303 114.273 100.394 110.42 97.2124C106.566 94.0311 102.124 91.6401 97.3463 90.1757C92.5688 88.7113 87.5496 88.2022 82.5753 88.6776C77.601 89.1529 72.7691 90.6034 68.3554 92.9461L50.5157 59.3362Z",
    fill: "#FFBA68"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_153_96",
    x: 0.515625,
    y: 0.453979,
    width: 202.899,
    height: 158.262,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 25,
    result: "effect1_foregroundBlur_153_96"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOrangeRing251);
export default __webpack_public_path__ + "static/media/orange-ring25-1.a5102f3edcc70786acc45b3fbc8e4d29.svg";
export { ForwardRef as ReactComponent };